export type AnimationType =
  | 'fadeIn'
  | 'fadeOut'
  | 'textFadeIn'
  | 'textFadeOut'
  | 'scaleIn'
  | 'scaleUp'
  | 'scaleUp4'
  | 'scaleDown';

// Main Fade In and Out animations
export function fadeIn(el: HTMLElement | null) {
  if (!el) return Promise.resolve();

  return el.animate([{ opacity: 0 }, { opacity: 1 }], {
    duration: 1200,
    easing: 'cubic-bezier(.2,.9,.3,.9)',
    delay: 350,
    fill: 'forwards',
  }).finished;
}

export function fadeOut(el: HTMLElement | null) {
  if (!el) return Promise.resolve();

  return el.animate([{ opacity: 1 }, { opacity: 0 }], {
    duration: 600,
    easing: 'cubic-bezier(.4,0,.2,1)',
    fill: 'forwards',
  }).finished;
}

// Fade in and Out animations for TEXT
export function textFadeIn(el: HTMLElement | null) {
  if (!el) return Promise.resolve();

  return el.animate(
    [
      { opacity: 0, transform: 'translateY(8px) scale(0.98)' },
      { opacity: 1, transform: 'translateY(0) scale(1)' },
    ],
    {
      duration: 1000,
      easing: 'cubic-bezier(.2,.9,.3,.9)',
      fill: 'forwards',
    },
  ).finished;
}

export function textFadeOut(el: HTMLElement | null) {
  if (!el) return Promise.resolve();

  return el.animate(
    [
      { opacity: 1, transform: 'translateY(0) scale(1)' },
      { opacity: 0, transform: 'translateY(8px) scale(0.98)' },
    ],
    {
      duration: 600,
      easing: 'cubic-bezier(.4,0,.2,1)',
      fill: 'forwards',
    },
  ).finished;
}

// Specific animations for other HTMLElements

export function scaleIn(el: HTMLElement | null) {
  if (!el) return Promise.resolve();

  return el.animate([{ transform: 'scale(0.8)' }, { transform: 'scale(1)' }], {
    duration: 400,
    easing: 'cubic-bezier(.2,.9,.3,1)',
    fill: 'forwards',
  }).finished;
}

export function scaleUp(el: HTMLElement | null) {
  if (!el) return Promise.resolve();

  return el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.45)' }], {
    duration: 500,
    delay: 100,
    easing: 'ease-in-out',
    fill: 'forwards',
  }).finished;

  // step2
}

export function scaleUp4(el: HTMLElement | null) {
  if (!el) return Promise.resolve();

  return el.animate(
    [
      { transform: 'scale(1.2)', opacity: 0 },
      { transform: 'scale(1.8)', opacity: 1 },
    ],
    {
      duration: 500,
      delay: 100,
      easing: 'ease-in-out',
      fill: 'forwards',
    },
  ).finished;

  // step4
}

export function scaleDown(el: HTMLElement | null) {
  if (!el) return Promise.resolve();

  return el.animate([{ transform: 'scale(1.45)' }, { transform: 'scale(1.2)' }], {
    duration: 500,
    delay: 100,
    easing: 'ease-in-out',
    fill: 'forwards',
  }).finished;

  // step3
}

// Export animations

export function animateElement(el: HTMLElement, animation: AnimationType) {
  switch (animation) {
    case 'fadeIn':
      return fadeIn(el);

    case 'fadeOut':
      return fadeOut(el);

    case 'textFadeIn':
      return fadeIn(el);

    case 'textFadeOut':
      return fadeOut(el);

    case 'scaleIn':
      return scaleIn(el);

    case 'scaleUp':
      return scaleUp(el);

    case 'scaleUp4':
      return scaleUp4(el);

    case 'scaleDown':
      return scaleDown(el);
  }
}
